export default __webpack_public_path__ + "static/media/linkedin.5a7fe093.svg";